require('utility-ng-enumeration');
require('utility-ng-interface');
require('utility-ng-time');
require('ui-ng-delegate');
require('ui-ng-time-input');

angular.module('ui-ng-calendar-time', [
  'utility-ng-enumeration',
  'utility-ng-interface',
  'utility-ng-time',
  'ui-ng-time-input',
  'ui-ng-delegate'
]);

require('./core');
require('./builders/calendar_week_time_builder');
require('./functions/calendar_week_time_functions');
require('./components/list_calendar_time/list_calendar_time');
require('./components/week_calendar_time/week_calendar_time');
require('./utilities/time_formatter');
require('./view/calendar_time');

// module.exports = 'ui-ng-calendar-time';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar-time/src/main.js